import React from 'react';
import { useTranslation } from 'react-i18next';
import './StatsCards.css';

interface StatsCardsProps {
  totalInstitutions: number;
  averageRating: string;
  upgradedCount: number;
  downgradedCount: number;
  comparisonPeriod: string;
}

const StatsCards: React.FC<StatsCardsProps> = ({
  totalInstitutions,
  averageRating,
  upgradedCount,
  downgradedCount,
  comparisonPeriod,
}) => {
  const { t } = useTranslation();

  return (
    <div className="stats-cards">
      <div className="stat-card">
        <div className="stat-card-label-group">
          <span className="stat-card-label">{t('map.totalInstitutions')}</span>
        </div>
        <span className="stat-card-value">{totalInstitutions}</span>
      </div>

      <div className="stat-card">
        <div className="stat-card-label-group">
          <span className="stat-card-label">{t('map.averageRating')}</span>
        </div>
        <span className="stat-card-value">{averageRating}</span>
      </div>

      <div className="stat-card">
        <div className="stat-card-label-group">
          <span className="stat-card-label">{t('map.upgraded')}</span>
          <span className="stat-card-vs">vs. {comparisonPeriod}</span>
        </div>
        <span className="stat-card-value stat-card-value--upgraded">{upgradedCount}</span>
      </div>

      <div className="stat-card">
        <div className="stat-card-label-group">
          <span className="stat-card-label">{t('map.downgraded')}</span>
          <span className="stat-card-vs">vs. {comparisonPeriod}</span>
        </div>
        <span className="stat-card-value stat-card-value--downgraded">{downgradedCount}</span>
      </div>
    </div>
  );
};

export default StatsCards;
